'use client';

import { DOWNLOAD_APP_BANNER_DISMISSED } from '@/domain/download-app-banner';
import { Banner } from '@/types/banner';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { LinkButton } from '../LinkButton/LinkButton';
import { MESSAGE_BOX_STATE, MessageBox } from '../MessageBox/MessageBox';

export function DownloadAppBanner({ content }: { content?: Banner }) {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    Cookies.set(DOWNLOAD_APP_BANNER_DISMISSED, 'true');
    setIsVisible(false);
  };

  if (!content || !isVisible) {
    return null;
  }

  const {
    data: { title, body, linkLabel, linkUrl },
  } = content;

  return (
    <div data-test-id="app-banner">
      <MessageBox
        message={'Download the app'}
        onClose={handleClose}
        state={MESSAGE_BOX_STATE.APP_BANNER}
        className="rounded-none border-t-0 border-r-0 border-b-2 border-l-0"
      >
        <div className="flex flex-col md:flex-row">
          <div className="flex-1">
            {title && <h3 className="mt-1 text-sm font-semibold">{title}</h3>}
            {body && (
              <div className="mb-1 flex place-content-between">
                <div className="[&_p]:m-0 [&_p]:text-sm" dangerouslySetInnerHTML={{ __html: body }} />
                <div className="mb-1 ml-1 flex h-auto items-center">
                  {linkLabel && linkUrl && (
                    <LinkButton
                      label={linkLabel}
                      link={linkUrl}
                      size="tiny"
                      variant="tertiary"
                      className="text-sm text-nowrap"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </MessageBox>
    </div>
  );
}
